import React, { useState, useEffect } from "react";
import MenuItems from "./menuitem";
import SocialMediaLinks from "./socialmedialinks";
import DiaryContent from "./menucontent/DairyContent";
import NotificationContent from "./menucontent/NotificationContent";
import AssignmentContent from "./menucontent/AssignmentContent";
import GenericPopup from "../genericpopup";
import defaultImage from "../../assets/default.png";

import UpcomingEvents from "./upcomingevent";
import CurrentEvents from "./currentevents";
import AiChaki from "./aiChaki";
import { useNavigate } from 'react-router-dom';
import ExamContent from "./menucontent/ExamContent";
import RemarksComponent from "./menucontent/RemarksComponent";
import CircularsContent from "./menucontent/CircularsContent";
import FeedbackContent from "./menucontent/FeedbackContent";
import StudentDiary from "./menucontent/StudentDiary";
import EventsContent from "./menucontent/EventsContent";
import PTMContent from "./menucontent/PTMContent";
import LiveClasses from "./menucontent/LiveClasses";
import OnlineTests from "./menucontent/OnlineTests";
import Finance from "./menucontent/Finance";
import Attendance from "./menucontent/Attendance";
import ServiceRequest from "./menucontent/ServiceRequest";
import Timetable from "./menucontent/Timetable";
import Transport from "./menucontent/Transport";
import GalleryContent from "./menucontent/GalleryContent";
import Classroom from "./menucontent/Classroom";
import Calendar from "./menucontent/Calendar";
// import PaymentHistory from "./menucontent/PaymentHistory";
import ProfileContent from "./menucontent/ProfileContent";
import CirclePosts from "./menucontent/CirclePosts";
import Assessments from "./menucontent/Assessments";
import HostelContent from "./menucontent/HostelContent";
import serviceApi from "../../services/serviceApi";
import environment from "../../environments/environment";
import KnowledgeBase from "./menucontent/knowledgeBase";
import OtherAssessment from "./menucontent/OtherAssessment";


interface Student {
  name: string;
  clss: string;
  phone1?: string;
  imageUrl?: string;
  course?: string;
  appMessage?: string;
  // notifications?: Notification[];

  // brandMsg?: string;


  socialMediaLinks?: SocialMediaLink[];
  upcomingEvents?: Event[]; promoEvent?: {
    title: string;
    logoUrl: string;
    description: string;
    action: string;
  };
  currentEvent?: CurrentEvent;
}


interface SocialMediaLink {
  name: string;
  logoUrl: string;
}
interface Event {
  title: string;
  description: string;
  dateTime: string;
  action: string;
}
interface CurrentEvent {
  title: string;
  description: string;
  dateTime: string;
  action: string;
}


interface ApiResponse {
  status: string;
  message: string;
  objectData?: {
    name: string;
    schoolLogo: string;
    tchrNoteBrandMsg: string;
    profiles: Student[];
    menuItems?: any;
    upcomingEvents?: Event[];
    currentEvents?: CurrentEvent[];

    appConfig?: {
      appMenus?: string;
      homePage?: string;
      appTheme?: string;
    };
  };

}




const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(true);
  const [student, setStudent] = useState<Student | null>(null);
  const [school, setSchool] = useState<{ name: string; logo: string; brandMsg: string }>({ name: "", logo: "", brandMsg: "" });
  const [selectedMenu, setSelectedMenu] = useState<string>('');
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [students, setStudents] = useState<Student[]>([]);
  const [showSiblingsPopup, setShowSiblingsPopup] = useState(false);
  const [newSiblingId, setNewSiblingId] = useState("");
  const [newSiblingPassword, setNewSiblingPassword] = useState("");
  const [showAddSiblingPopup, setShowAddSiblingPopup] = useState(false);
  // const [errorPopup, setErrorPopup] = useState<string | null>(null);
  // const [successPopup, setSuccessPopup] = useState<string | null>(null);
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [showSchoolCircle, setShowSchoolCircle] = useState(false);
  const [apiMessage, setApiMessage] = useState<string | null>(null);


  const loadBackendData = () => {
    const storedData = localStorage.getItem("backendResponse");
    if (!storedData) return;
    const parsed: ApiResponse = JSON.parse(storedData);
    if (!parsed.objectData) return;
    const objectData = parsed.objectData;
    const appMenusString =
      objectData?.appConfig?.appMenus;
    let appMenus: any = {};
    try {
      appMenus =
        typeof appMenusString === "string"
          ? JSON.parse(appMenusString)
          : appMenusString;
    } catch (err) {
      console.error("appMenus parse error", err);
    }
    setShowSchoolCircle(appMenus?.schoolCircle === true);
    setSchool({
      name: objectData.name,
      logo: objectData.schoolLogo,
      brandMsg: objectData.tchrNoteBrandMsg,
    });

    const selected = localStorage.getItem("selectedStudent");
    const all = localStorage.getItem("allStudents");
    if (all) setStudents(JSON.parse(all));
    if (selected) setStudent(JSON.parse(selected));
  };

  useEffect(() => {
    loadBackendData();
  }, []);
  const handleStudentClick = (s: Student) => {
    setStudent(s);
    localStorage.setItem("selectedStudent", JSON.stringify(s));
  }

  const handleAddSibling = () => {
    // Navigate to add sibling page (or popup)
    setShowSiblingsPopup(false);
    setShowAddSiblingPopup(true);


  }



  const handleProceedAddSibling = () => {
    setShowAddSiblingPopup(false);
    setConfirmPopup(true);
    // if (newSiblingId && newSiblingPassword) {
    //   setShowAddSiblingPopup(false);
    //   // Show confirm popup 
    //   setConfirmPopup(true);
    // } else {
    //   // Show error popup instead of Swal
    //   setErrorPopup("Please enter both ID and Password");
    // }
  }

  return (
    <div className="dashboard-page">
      {/* Title Bar */}
      {/* <div
        className={`title-bar title-bar-responsive`}
        style={{
          left: isOpen ? "250px" : "0",
          width: isOpen ? "calc(100% - 250px)" : "100%",
        }}
      > */}
      {!isOpen && (
        <button className="toggle-button" onClick={() => setIsOpen(true)}>
          <i className="fas fa-bars icon-animate"></i>
        </button>
      )}
      {/* <MenuItems onMenuSelect={(key) => {

          setSelectedMenu(key.toLowerCase());
          console.log("Selected menu:", key.toLowerCase());
        }} />

      </div> */}

      {/* Navbar */}
      {isOpen && (
        <div className="navbar">
          <button className="close-button" onClick={() => setIsOpen(false)}>
            <i className="fas fa-times icon-animate"></i>
          </button>

          {/* {school Logo} */}
          <div className="school-header">

            {school.logo && (
              <div className="dashboard-logo-container">
                <img src={school.logo} alt={"School.name"} className="school-logo dashboard-school-logo" />
              </div>
            )}

          </div>

          {student && (
            <div className="student-navbar-card">
              <div className="student-navbar-info">
                <img
                  src={student.imageUrl?.trim() ? student.imageUrl : defaultImage}
                  alt={student.name}
                  className="student-navbar-photo"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).src = defaultImage;
                  }}
                />
                <div className="student-navbar-details">
                  <h3 className="student-details-margin">{student.name}</h3>
                  <p className="student-details-margin-zero">
                    Class: {student.clss} | {student.course}

                  </p>

                </div>
              </div>

              <div className="student-divider"></div>

              {/* sibling  button */}
              <div className="button-container">
                <button onClick={() => setShowSiblingsPopup(true)} className="plus-button">
                  Siblings
                </button>

                {/* profile button */}
                <button className="profile-button"
                  onClick={() => setSelectedMenu("profile")}
                >
                  Profile

                </button>
              </div>



            </div>
          )}
          {/* Popup Modal for selectsiblings */}
          <GenericPopup
            isOpen={showSiblingsPopup}
            type="custom"
            title="Select Sibling"
            onClose={() => setShowSiblingsPopup(false)}

          >
            <div className="siblings-list-popup">
              {
                students
                  .filter((s) => s.name !== student?.name)
                  .map((sib, idx) => (
                    <div
                      key={idx}
                      className="sibling-card"
                      onClick={() => {
                        handleStudentClick(sib);
                        setShowSiblingsPopup(false);
                      }}
                    >
                      <img
                        src={sib.imageUrl?.trim() ? sib.imageUrl : defaultImage}
                        alt={sib.name}
                        className="sibling-photo"
                        onError={(e) => {
                          (e.currentTarget as HTMLImageElement).src = defaultImage;
                        }}
                      />
                      <div>
                        <h5>{sib.name}</h5>
                        <p>{sib.clss}</p>
                      </div>

                    </div>

                  ))

              }
              <div className="sibling-card add-sibling" onClick={handleAddSibling}>
                <div className="plus-circle">+</div>
                <span>Add Sibling</span>
              </div>


            </div>


          </GenericPopup>


          {/* dashboard button */}
          <div
            className="dashboard-button"
            onClick={() => setSelectedMenu("")}

          >
            <i className="fa-regular fa-house"></i> Dashboard
          </div>

          {/* Navbar filtered menu */}
          <MenuItems navbarOnly={true} onMenuSelect={(key) => {
            setSelectedMenu(key.toLowerCase());
          }} />

          {/* Navbar Bottom Section */}
          <div className="navbar-bottom">
            <div className="icon-container">
              <button className="icon-btn settings-btn">
                <i className="fas fa-cog"></i>
              </button>

              <button className="icon-btn logout-btn" onClick={() => setShowLogoutConfirm(true)}>
                <i className="fas fa-sign-out-alt"></i>
              </button>
            </div>

            <span className="navbar-brandMsg">{school?.brandMsg}</span>



            {/* popup logic for logout*/}

            {/* popup logic for logout */}
            <GenericPopup
              isOpen={showLogoutConfirm}
              type="confirm"
              title="Logout"
              message="Are you sure you want to logout?"
              onClose={() => setShowLogoutConfirm(false)}
              onConfirm={() => {
                sessionStorage.clear();
                navigate("/", { replace: true });
              }}
            />



          </div>

        </div>

      )}


      <GenericPopup

        isOpen={showAddSiblingPopup}
        type="custom"
        title='Add Sibling'
        onClose={() => setShowAddSiblingPopup(false)}

      >
        <div className="add-sibling-form">
          <label>Qpass Id:</label>
          <input
            type="text"
            value={newSiblingId}
            onChange={(e) => setNewSiblingId(e.target.value)}

          />
          <label>Password:</label>
          <input
            type="password"
            value={newSiblingPassword}
            onChange={(e) => setNewSiblingPassword(e.target.value)}
          />

          <button className="proceed-btn" onClick={handleProceedAddSibling}>
            Proceed
          </button>

        </div>


      </GenericPopup>

      {/* ❌ Error Popup */}
      {/* <GenericPopup
        isOpen={!!errorPopup}
        type="alert"
        title="Error"
        message={errorPopup || ""}
        onClose={() => setErrorPopup(null)

        }
      /> */}

      {/* ⚠️ Confirm Popup */}
      <GenericPopup
        isOpen={confirmPopup}
        type="confirm"
        title="Confirm"
        message="Do you want to add this sibling?"
        onClose={() => setConfirmPopup(false)}
        // onConfirm={() => {
        //   // sibling add logic
        //   const newSibling: Student = {
        //     name: `Sibling ${students.length + 1}`,
        //     clss: "N/A",
        //     course: "N/A",
        //     imageUrl: "https://via.placeholder.com/50",
        //   };

        //   // setStudents((prev) => [...prev, newSibling]);
        //   setStudents((prev) => {
        //     const updated = [...prev, newSibling];
        //     localStorage.setItem("allStudents", JSON.stringify(updated));
        //     return updated;
        //   });
        //   setNewSiblingId("");
        //   setNewSiblingPassword("");

        //   setConfirmPopup(false);
        //   setSuccessPopup("Your sibling has been added successfully.");
        // }}

        onConfirm={async () => {
          try {
            const payload = {
              siblingId: newSiblingId,
              password: newSiblingPassword,
            };

            const response: any = await serviceApi.put(
              environment.addSibling,
              payload
            );
            console.log("students:", response?.objectData?.students);
            console.log("msg:", response?.objectData?.msg);
            console.log("Add sibling response:", response);

            setConfirmPopup(false);

            if (response?.objectData?.students?.length > 0) {
              localStorage.setItem(
                "allStudents",
                JSON.stringify(response.objectData.students)
              );

              setStudents(response.objectData.students);

              setNewSiblingId("");
              setNewSiblingPassword("");

              setApiMessage(
                response?.objectData?.msg || "Sibling added successfully"
              );

              setShowSiblingsPopup(true);
            } else {
              setApiMessage(
                response?.objectData?.msg || "Failed to add sibling"
              );
            }
          } catch (error) {
            console.error("Add sibling failed:", error);
            setConfirmPopup(false);
          }
        }}
      />
      <GenericPopup
        isOpen={!!apiMessage}
        type="alert"
        title="Message"
        message={apiMessage || ""}
        onClose={() => setApiMessage(null)}
      />
      {/* ✅ Success Popup */}
      {/* <GenericPopup
        isOpen={!!successPopup}
        type="alert"
        title="Added!"
        message={successPopup || ""}
        onClose={() => {
          setSuccessPopup(null)
          setShowSiblingsPopup(true);
        }}

      /> */}

      {/* Main Content */}
      <div
        className={`main-content main-content-responsive`}
        style={{
          marginLeft: isOpen ? "250px" : "0",
        }}
      >
        <div className="dashboard-layout"
          style={{
            display: "flex",
            width: "100%"
          }}
        >

          <div className="main-area"
            style={{
              flex: showSchoolCircle ? 1 : "100%",
              width: showSchoolCircle ? undefined : "100%"
            }}
          >
            {/* Dynamic Header */}
            {selectedMenu && (
              <div className="content-header">
                <button
                  className="back-btn"
                  onClick={() => setSelectedMenu("")}
                > ← </button>
              </div>
            )}
            {selectedMenu === 'diary' && <DiaryContent student={student || undefined} />}
            {selectedMenu === 'notifications' && student && (
              <NotificationContent student={student} school={{ name: school.name, logo: school.logo }} />
            )}

            {selectedMenu === 'assignments' && <AssignmentContent />}
            {selectedMenu === 'exams' && <ExamContent />}
            {selectedMenu === 'remarks' && <RemarksComponent />}
            {selectedMenu === 'circulars' && <CircularsContent />}
            {selectedMenu === 'feedback' && <FeedbackContent />}
            {selectedMenu === 'studentdiary' && <StudentDiary />}
            {selectedMenu === 'events' && <EventsContent />}
            {selectedMenu === 'ptms' && <PTMContent />}
            {selectedMenu === 'servicerequests' && <ServiceRequest />}
            {selectedMenu === 'liveclasses' && <LiveClasses />}
            {selectedMenu === 'onlinetests' && <OnlineTests />}
            {selectedMenu === 'finance' && <Finance />}
            {selectedMenu === 'attendance' && <Attendance />}
            {selectedMenu === 'timetable' && <Timetable />}
            {selectedMenu === 'transport' && <Transport />}
            {selectedMenu === 'gallery' && <GalleryContent />}
            {selectedMenu === 'classroom' && <Classroom />}
            {selectedMenu === 'calendar' && <Calendar />}
            {/* {selectedMenu === 'paymenthistory' && <PaymentHistory />} */}
            {selectedMenu === 'profile' && <ProfileContent />}
            {selectedMenu === 'assessments' && <Assessments />}
            {selectedMenu === 'hostel' && <HostelContent />}
            {selectedMenu === 'knowledgebase' && <KnowledgeBase />}
            {selectedMenu === 'otherassessment' && <OtherAssessment />}
            {/* {selectedMenu === "schoolcircle" && <CirclePosts />} */}

            {/* Default Dashboard view */}
            {!selectedMenu && (
              <>
                {/* Note card */}
                <div className="event-container">
                  <h3 className="title-text">Note</h3>
                  <p className="event-description">
                    {student?.appMessage || "No message available"}
                  </p>
                </div>
                {/* UpcomingEvents card */}
                <div className="event-container">
                  <h3 className="title-text">UpcomingEvents</h3>
                  <UpcomingEvents events={student?.upcomingEvents || []} />
                </div>
                {/* CurrentEvents card */}
                <div className="event-container">
                  <h3 className="title-text">CurrentEvents</h3>
                  <CurrentEvents events={student?.currentEvent ? [student.currentEvent] : []} />
                </div>
                {/* <UpcomingEvents events={student?.upcomingEvents || []} />
                <CurrentEvents events={student?.currentEvent ? [student.currentEvent] : []} /> */}
                <SocialMediaLinks links={student?.socialMediaLinks || []} />

              </>
            )}
            <AiChaki promoEvent={student?.promoEvent} />

          </div>
          {showSchoolCircle && (
            <div className="school-circle-panel">
              <div className="panel-body">
                <CirclePosts />
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default Dashboard;
